<template>
  <div class="daily-details">
    <title-bar class="title-bar-view" :title="'题目描述'" :showAll="false"></title-bar>
    <div class="div-txt">{{ dayDetails && dayDetails.questionTitle }}</div>
    <div class="div-imgs">
      <div class="imgs" :style="`background-image: url(${questionImage.url})`" @click="handleClickImgs">
        <img :src="questionImage && questionImage.url" style="visibility: hidden;" class="imgs img-block" alt="">
      </div>
      <div v-if="questionVideo && Object.keys(questionVideo).length > 0" class="imgs"
           :style="`background-image: url(${questionVideo.url})`" @click="handleClickQuesion">
        <img :src="questionVideo && questionVideo.url" style="visibility: hidden;" class="imgs img-block" alt="">
        <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
      </div>
    </div>
    <!-- <div class="fixed-btn" @click="answerDialog = true">{{ !dayDetails.isAnswer ? '选择答案' : '查看答案' }}</div> -->
    <!-- <div class="dialog-div" v-show="answerDialog">
      <div class="dialog-bg" @click="answerDialog = false"></div> -->
    <div class="wrapper" @click.stop>
      <title-bar class="title-bar-view" :title="`选择答案(${dayDetails.questionType === '1' ? '单选题' : '多选题'})`"
                 :showAll="false"></title-bar>
      <div class="wrapper-con">
        <div class="change-list">
          <div class="item-txt" :class="itemIds.includes(item.id) ? 'cur' : ''"
               v-for="(item, index) in dayDetails.questionOptions" :key="index" @click="handleClickItems(item.id)">
            {{ item && item.optionContent }}
          </div>
        </div>
        <div class="answer-txt true" v-if="userAnswer.length > 0 && answerIsTrue === 'true'">回答正确</div>
        <div class="answer-txt" v-if="userAnswer.length > 0 && answerIsTrue === 'false'">回答错误</div>
        <div class="true-tip-block" v-if="userAnswer.length > 0">
          <div class="true-txt1">
            <span class="label">答案：</span>
            {{ trueTxt }}
          </div>
          <div class="true-txt1 true-txt2" v-if="dayDetails && dayDetails.remark">
            <span class="label">临床结论：</span>
            {{ dayDetails.remark }}
          </div>
          <div class="true-txt1" v-if="analysisVideo && Object.keys(analysisVideo).length > 0">
            视频解析:
            <div class="video-div" @click="handlePlayVideo">
              <img src="@/assets/images/home/bg_question1@2x.png" class="video-cover" alt="">
            </div>
          </div>
          <div class="true-txt1"
               v-if="questionCourses.length > 0 || questionDocuments.length > 0 || questionCases.length > 0">
            <span class="span-txt">本题知识点来源:</span>
            <div class="right-con">
              <div v-if="questionCourses.length > 0">
                <div class="right-txt" v-for="(item, index) in questionCourses"
                     @click="handleDialogUnlock('course', item)" :key="index">
                  <span class="tag-txt">课程</span>
                  <div class="title-txt">
                    <img v-if="`${item.isUnlock}` === '1' && !item.myUnlock" src="@/assets/images/data-base/unlock.png"
                         class="icon-unlock" alt="">
                    {{ item && item.courseName }}
                  </div>
                  <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                </div>
              </div>
              <div v-if="questionCases.length > 0">
                <div class="right-txt" @click="handleDialogUnlock('case', item)" v-for="(item, index) in questionCases"
                     :key="index">
                  <span class="tag-txt">病例</span>
                  <div class="title-txt">{{ item && item.caseDetail.title }}</div>
                  <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                </div>
              </div>
              <div v-if="questionDocuments.length > 0">
                <div class="right-txt" @click="handleDialogUnlock('document', item)"
                     v-for="(item, index) in questionDocuments" :key="index">
                  <span class="tag-txt">文献</span>
                  <div class="title-txt">{{ item && item.documentDetail.title }}</div>
                  <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="div-block-tips">
            该部分内容由专家提供，仅代表专家个人观点。供医疗卫生专业人士学术交流目的使用，仅供参考。临床的具体情况请以专业人士的临床诊断为准。
          </div>
        </div>
        <!-- <div class="wrapper-btn" v-if="userAnswer.length <= 0" @click="handleSubmit">确认答案</div> -->
      </div>
    </div>
    <div class="fix-btn">
      <div class="btn-txt" v-if="userAnswer.length <= 0 && !isAnswerBool" @click="handleSubmit">确认答案</div>
      <div class="flex-btn">
        <div class="btn-item" @click="handleCollect">
          <img v-if="isCollect" src="@/assets/images/questionBank/img(8).png" class="item-icon" alt="">
          <img v-else src="@/assets/images/questionBank/img(16).png" class="item-icon" alt="">
          <div class="item-txt">收藏</div>
        </div>
        <div class="btn-item" @click="isFeedBack = true">
          <img src="@/assets/images/questionBank/img(15).png" class="item-icon" alt="">
          <div class="item-txt">纠错</div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="dialog-video" v-if="videoDialog">
      <div class="dialog-video-bg" @click.stop="handlePauseVideo"></div>
      <VideoPlayerAnswer ref="video" :playerVideo="analysisVideo"></VideoPlayerAnswer>
    </div>

    <van-overlay :show="isFeedBack" @click="isFeedBack = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">纠错反馈</div>
        <div class="wrap-con">
          <van-field v-model="feedModel" rows="2" autosize type="textarea" maxlength="200"
                     placeholder="请输入您的反馈..."
                     show-word-limit/>
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isFeedBack = false">取消</div>
          <div class="btn btn2" @click="handleFeedBack('feedback')">提交反馈</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showImage" class="loading-overlay">
      <van-loading type="spinner"/>
    </van-overlay>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleClick" :dataProps="dataProps"></dialog-unlock>
  </div>
</template>
<script>
import {getDaily, questionUser, sendFeedback} from '@/api/api'
import TitleBar from '../../components/TitleBar.vue'
import VideoPlayerAnswer from './components/VideoPlayerAnswer.vue'
import {setSha, traceClickURL, throttle} from '../../utils/util'
import {ImagePreview} from 'vant'
import {getShareInfo} from '@/utils/wxShare'
import {postCollect, delCollect} from '@/api/questionBank'
import dialogUnlock from '@/components/dialogUnlock.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import {canScroll} from '@/utils/util'
import {debounce} from 'lodash-es'
import {isScorm} from '../../api/scorm'
import {getIsCorrect} from '../../api/api'

const UserProfile = {
  components: {
    TitleBar,
    VideoPlayerAnswer,
    dialogUnlock
  },
  data() {
    return {
      dayDetails: {},
      answerDialog: false,
      questionImage: {},
      questionVideo: {},
      itemIds: [],
      userAnswer: [],
      trueAnswerId: [],
      answerIsTrue: '',
      trueTxt: '',
      // 知识来源课程
      questionCourses: [],
      // 知识来源文献
      questionDocuments: [],
      // 知识来源病例
      questionCases: [],
      // 解析视频
      analysisVideo: {},
      videoDialog: false,
      isCollect: false,
      isFeedBack: false,
      feedModel: '',
      showImage: false,
      isAnswerBool: false,
      dataDetails: {},
      typeTxt: '',
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
      isCorrect: '',
      isFeedbackSubmitting: false
    }
  },
  watch: {
    // answerDialog (newval, oldval) {
    //   localStorage.setItem('answerDialog', newval)
    //   if (newval) {
    //     stopScroll()
    //   } else {
    //     canScroll()
    //   }
    // }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    canScroll()
    this.handleFun()
  },
  methods: {
    // 反馈操作
    handleFeedBack: throttle(function(type) {
      if (this.isFeedbackSubmitting) {
        return
      }
      if (!this.feedModel) {
        this.$toast('请先输入内容再提交！')
        return
      }
      this.isFeedbackSubmitting = true
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      let content = ''
      if (type === 'feedback') {
        content = this.feedModel
      }
      let params = {
        type: 3,
        baseId: this.dayDetails.id,
        baseTitle: `${this.dayDetails.questionClassEntity ? this.dayDetails.questionClassEntity.className : ''}-LV${this.dayDetails.difficultyLevel}-${this.dayDetails.questionNumber}`,
        content,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      const loading = this.$toast({
        message: '提交中...',
        forbidClick: true
      })
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.$toast('反馈成功')
          return
        }
        this.$toast(res.msg || '反馈失败')
      }).catch(() => {
        this.$toast('反馈失败，请稍后重试')
      }).finally(() => {
        loading.clear()
        this.isFeedBack = false
        this.isFeedbackSubmitting = false
      })
    }, 500),
    // 收藏
    handleCollect() {
      let params = {
        'userId': this.userInfo.id,
        'questionId': this.questionId
      }
      if (this.isCollect) {
        delCollect(params).then(res => {
          this.$toast('取消收藏')
          this.isCollect = false
        })
      } else {
        postCollect(params).then(res => {
          this.$toast('收藏成功')
          this.isCollect = true
          this.isCollect = true
        })
      }
    },
    handleClickImgs() {
      this.showImage = true
      this.imgToBase64(this.questionImage.url).then(imgUrl => {
        this.showImage = false
        ImagePreview({
          images: [imgUrl],
          showIndex: false,
          closeable: true
        })
      })
    },

    async handleFun() {
      const res = await getDaily()
      this.dayDetails = res.data
      if (!this.dayDetails) {
        this.$toast('暂无题目返回')
        return
      }
      this.questionId = this.dayDetails.id
      sessionStorage.setItem('questionId', this.questionId)
      window.sessionStorage.setItem('serviceId', this.dayDetails.id)
      window.sessionStorage.setItem('mainId', this.dayDetails.id)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : 31
      window.sessionStorage.setItem('entrance', entrance)
      if (window.location.href.includes('entrance')) {
        window.sessionStorage.setItem('moduleName', '每日一题')
      }
      getShareInfo({
        title: 'iEP-心电图读图',
        titleTimeLine: 'iEP-海量心电图读图学习，积跬步，至千里',
        desc: '一起学习，快来看看这个心电图',
        link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '33'),
        linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '34'),
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
      this.isCollect = this.dayDetails.isCollect
      if (res.data.questionImage) {
        this.questionImage = res.data.questionImage
      }
      if (res.data.questionVideo) {
        this.questionVideo = res.data.questionVideo
      }
      this.answerIsTrue = ''
      if (res.data.userAnswer && res.data.userAnswer.length > 0) {
        // 判断回答是否正确
        await this.getAnswerIsTrue()
      }
      this.userAnswer = res.data.userAnswer
      // this.answerDialog = JSON.parse(localStorage.getItem('answerDialog')) && this.userAnswer.length > 0

      // 获取正确答案得id
      this.trueAnswerIdArr = res.data.questionAnswers.map(item => item.optionAnswer)
      this.trueAnswerId = this.trueAnswerIdArr.map(item => item.id).sort()
      // 获取正确答案的txt
      this.trueTxt = res.data.questionAnswers.map(item => item.optionAnswer.optionContent).toString()
      if (this.userAnswer.length > 0) {
        this.itemIds = this.userAnswer.map(item => item.questionOption.id).sort()
      }
      this.questionCourses = res.data.questionCourses
      this.questionDocuments = res.data.questionDocuments
      this.questionCases = res.data.questionCases
      this.analysisVideo = res.data.analysisVideo
    },
    async getAnswerIsTrue() {
      try {
        const result = await getIsCorrect({
          userId: this.userInfo.id,
          questionId: this.questionId,
        })
        if (result.code === 0) {
          this.answerIsTrue = `${result.data}`
          return
        }
        this.answerIsTrue = ''
      } catch (e) {
      }
    },
    handleDialogUnlock(type, item) {
      this.dataDetails = item
      this.typeTxt = type
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.courseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleClick()
    },
    // 跳转知识点来源
    async handleClick() {
      window.sessionStorage.setItem('entrance', '8')
      let item = this.dataDetails
      let type = this.typeTxt
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=8&businessChannel=8&campId=${this.dayDetails.journeyId || ''}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (type === 'course') {
        const query = {
          courseId: item.courseId,
          journeyId: this.dayDetails.journeyId,
          businessId: this.dayDetails.journeyId,
          entrance: '8',
          channel: '8'
        }
        const isscorm = await isScorm(item.courseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      } else if (type === 'case') {
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.caseId}${openidBindli}&id=${item.caseId}${trackParams}`
      } else if (type === 'document') {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            journeyId: this.dayDetails.journeyId,
            businessId: this.dayDetails.journeyId,
            entrance: '8',
            channel: '8'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.documentId}${openid}${iepTxt}${trackParams}`
      }
    },
    // 选择答案
    handleClickItems(id) {
      if (this.userAnswer.length > 0) {
        return
      }
      if (this.dayDetails.questionType === '1') {
        this.itemIds = [id]
      } else {
        if (this.itemIds.includes(id)) {
          this.itemIds = this.itemIds.filter(res => res !== id)
        } else {
          this.itemIds.push(id)
        }
      }
    },
    handleSubmit: debounce(function() {
      if (this.itemIds.length === 0) {
        this.$toast('作题答案不能为空！')
        return
      }
      if (this.dayDetails.questionType === '2' && this.itemIds.length < 2) {
        this.$toast('该题为多选题，请至少选择两个选项！')
        return
      }
      this.isAnswerBool = true
      let params = {
        classCode: this.dayDetails.questionClass,
        difficultyLevel: this.dayDetails.difficultyLevel,
        questionId: this.dayDetails.id,
        iepUserId: this.userInfo.id,
        optionIds: this.itemIds
      }
      questionUser(params).then(res => {
        this.handleFun()
        this.isCorrect = `${res.data.isCorrect}`
      }).catch((err) => {
        this.isAnswerBool = false
        this.$toast(err.msg)
      })
    }, 500),
    // 播放问题视频
    handleClickQuesion() {
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.questionVideo
      this.videoDialog = true
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId = this.dayDetails.questionVideoId
        this.$refs.video.player.play() // 尝试再次执行播放
      })
    },
    // 播放视频
    handlePlayVideo() {
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.analysisVideo
      this.videoDialog = true
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId = this.dayDetails.analysisVideo.id
        this.$refs.video.player.play() // 尝试再次执行播放
      })
    },
    // 暂停视频
    handlePauseVideo() {
      this.resetVideoTraceSession()
      this.videoDialog = false
      this.$refs.video.player.pause() // 尝试再次执行播放
    },
    resetVideoTraceSession() {
      if (this.videoDialog && this.$refs.video && this.$refs.video.handleVideoTrace) {
        this.$refs.video.handleVideoTrace(this.$refs.video.curVideoPlayer)
      }
      sessionStorage.removeItem('curPlaySessionVideo')
      sessionStorage.removeItem('videoSectionId')
      sessionStorage.removeItem('videoTraceId')
    },

    imgToBase64(url) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = url
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = () => {
          // 获取最后一个.的位置
          var index = url.lastIndexOf('.')
          // 获取后缀
          var ext = url.substr(index + 1).toLowerCase()

          const canvas = document.createElement('canvas')
          canvas.width = image.naturalWidth // 使用 naturalWidth 为了保证图片的清晰度
          canvas.height = image.naturalHeight
          canvas.style.width = `${canvas.width / window.devicePixelRatio}px`
          canvas.style.height = `${canvas.height / window.devicePixelRatio}px`
          const ctx = canvas.getContext('2d')
          if (!ctx) {
            return null
          }
          ctx.drawImage(image, 0, 0)

          ctx.font = '50px Arial' // 设置字体大小和字体
          ctx.rotate(-0.2) // 设置文字旋转角度
          ctx.globalAlpha = 0.2
          // 创建实体水印
          ctx.fillStyle = '#545454' // 颜色
          ctx.textAlign = 'left'
          ctx.textBaseline = 'Middle'

          for (var x = -800; x <= 3200; x += 400) {
            for (var y = -1200; y <= 6000; y += 300) {
              var text = 'iEP-心电图答题'
              for (var i = 1; this.getTrueLength(text) > 0; i++) {
                var tl = this.cutString(text, 10)
                ctx.fillText(text.substr(0, tl).replace(/^\s+|\s+$/, ''), x, i * 60 + y)
                // ctx.strokeText(text.substr(0, tl).replace(/^\s+|\s+$/, ""), x, i * 100 + y);
                text = text.substr(tl)
              }
            }
          }

          const base64 = canvas.toDataURL('image/' + ext)

          return resolve(base64)
        }
        image.onerror = (err) => {
          return reject(err)
        }
      })
    },
    getTrueLength(str) { // 获取字符串的真实长度（字节长度）
      let len = str.length
      let truelen = 0
      for (var x = 0; x < len; x++) {
        if (str.charCodeAt(x) > 128) {
          truelen += 2
        } else {
          truelen += 1
        }
      }
      return truelen
    },

    cutString(str, leng) { // 按字节长度截取字符串，返回substr截取位置
      let len = str.length
      let tlen = len
      let nlen = 0
      for (var x = 0; x < len; x++) {
        if (str.charCodeAt(x) > 128) {
          if (nlen + 2 < leng) {
            nlen += 2
          } else {
            tlen = x
            break
          }
        } else {
          if (nlen + 1 < leng) {
            nlen += 1
          } else {
            tlen = x
            break
          }
        }
      }
      return tlen
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.daily-details {
  padding: 16px 20px;
  box-sizing: border-box;
  padding-bottom: 140px;
  min-height: 100vh;
  width: 100%;

  .tag-div {
    width: 68px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background-color: #EB1700;
    border-radius: 4px;
    font-size: 12px;
    color: #FFFFFF;
    margin-bottom: 6px;
  }

  .div-txt {
    font-size: 14px;
    line-height: 24px;
    color: #333;
  }

  .div-imgs {
    .imgs {
      width: 100%;
      display: block;
      margin-top: 10px;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;

      .img-block {
        pointer-events: none;
      }
    }

    .icon-play {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .fixed-btn {
    width: 352px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    background-color: #EB1700;
    border-radius: 100px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .dialog-div {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    top: 0;
    left: 0;

    .dialog-bg {
      background-color: rgba(0, 0, 0, .5);
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 9;
      top: 0;
      left: 0;
    }
  }

  .wrapper {
    z-index: 9;
    bottom: 0;
    background-color: #fff;
    padding-top: 0;

    .title-bar-view {
      padding-top: 24px;
      padding-bottom: 15px;
      position: sticky;
      top: 0;
      background-color: #fff;
      margin-bottom: 0;
      box-sizing: border-box;
      z-index: 9;
    }

    .wrapper-con {
      box-sizing: border-box;
    }

    .change-list {
      .item-txt {
        width: 100%;
        margin-bottom: 13px;
        font-size: 14px;
        background: rgb(249, 248, 247);
        color: #333333;
        padding: 10px 20px;
        box-sizing: border-box;
        border: 1px solid #fff;
        border-radius: 20px;

        &.cur {
          background-color: #EB1700;
          color: #FFFFFF;
        }
      }
    }

    .answer-txt {
      font-size: 14px;
      color: #EB1700;
      text-align: center;

      &.true {
        color: #328714;
      }
    }

    .wrapper-btn {
      width: 352px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 30px;
      background-color: #EB1700;
      border-radius: 100px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .true-tip-block {
      background-color: #F5F6F8;
      padding: 10px 16px;
      box-sizing: border-box;
      margin-top: 16px;

      .true-txt1 {
        font-size: 14px;
        color: #6A7481;
        font-weight: 500;
        margin-bottom: 16px;
        line-height: 20px;
        display: flex;
        flex-wrap: wrap;

        &.true-txt2 {
          max-height: 140px;
          overflow-y: auto;
        }

        .label {
          font-size: 14px;
          color: #313235;
          font-weight: 600;
        }

        .span-txt {
          width: 100%;
          display: block;
          color: #313235;
          font-weight: 600;
        }

        .right-con {
          width: 100%;

          .right-txt {
            display: flex;
            align-items: center;
            width: 100%;
            height: 38px;
            margin-top: 8px;
            background: rgba(255, 91, 12, 0.08);
            justify-content: space-between;
            padding-left: 12px;
            padding-right: 8px;
            box-sizing: border-box;
            border-radius: 4px;

            .tag-txt {
              width: 30px;
              height: 16px;
              border-radius: 4px;
              background-color: #EB1700;
              text-align: center;
              line-height: 16px;
              font-size: 12px;
              color: #FFFFFF;
            }

            .title-txt {
              font-size: 14px;
              color: #EB1700;
              width: 220px;
              white-space: nowrap;
              overflow: hidden;
              display: block;
              text-overflow: ellipsis;
              display: flex;
              align-items: center;

              .icon-unlock {
                width: 10px;
                margin-right: 4px;
                display: block;
              }
            }

            .icon-more {
              width: 16px;
              height: 16px;
              display: block;
            }
          }
        }

        .video-div {
          position: relative;
          width: 137px;
          height: 72px;
          display: block;
          margin-left: 20px;

          .video-cover {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .icon-play {
            width: 23px;
            height: 23px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    .div-block-tips {
      margin-left: 50%;
      transform: translateX(-50%);
      background-color: #EDEEF5;
      border-radius: 4px;
      color: #6A7481;
      font-size: 10px;
      line-height: 20px;
      width: 100%;
      margin-top: 18px;
      padding: 10px 12px;
      box-sizing: border-box;
    }
  }

}

.fix-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #F1F1F1;
  padding: 8px 10px;
  box-sizing: border-box;
  width: 100vw;

  .btn-txt {
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 40px;
    background-color: #EB1700;
    border-radius: 100px;
    margin-bottom: 18px;
  }

  .flex-btn {
    display: flex;
    align-items: center;

    .btn-item {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .item-icon {
        width: 20px;
        height: 20px;
        display: block;
        margin-bottom: 4px;
      }

      .item-txt {
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>
<style scoped>
.dialog-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.dialog-video-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .6);
}

.player {
  position: relative;
  width: 100%;
  height: 200px;
  top: 50%;
  margin-top: -50%;
  z-index: 99999;
}

.player.isFullPlayer {
  position: static;
  height: auto;
  top: 0;
  margin-top: 0;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/home/dailyDetails.vue